import React from 'react';
import { Button, Table, Tooltip, message } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { utcToDefaultFormat } from '../../../Utils/date';
import PrintPrice from '../../../Components/PrintPrice';
import { ReceiptOutlined, ShoppingCartCheckout, ShoppingCartCheckoutOutlined } from '@mui/icons-material';
import { downloadInvoicePDFMgr, payInvoice, removeInvoice } from '../../../Reducers/balance';
import GetInventoryOrderButton from '../../Orders/OrderItem/GetInventoryOrderButton';
import PrintStatusInvoice from '../PrintStatusInvoice';
import { CreditCardOutlined, DeleteOutlined } from '@ant-design/icons';
import PrintStateInvoice from '../PrintStateInvoice';
import PrintOrdersLinks from '../PrintOrdersLinks';
import './styles.scss'

const { Column } = Table;

function PrintBalance({ 
  balance
}) {
  return (
    <span style={balance < 0 ? { color: 'red' } : null}>
      <PrintPrice price={balance} />
    </span>
  );
}

PrintBalance.propTypes = {
  balance: PropTypes.number.isRequired,
};

function PrintAmount({ amount }) {
  return (
    <span style={amount > 0 ? { color: 'green' } : null}>
      <PrintPrice price={amount} />
    </span>
  );
}

PrintAmount.propTypes = {
  amount: PropTypes.number.isRequired,
};

function ReplenishmentTable({
  isManager,
  transactionsData,
  selected,
  onSelectChange,
  handleFetch,
  newInvoiceId
}) {


  return (
    <Table
      rowClassName={(record) => record.id === newInvoiceId ? "highlight-row" : ""}
      bordered
      className="ant-table-white-bg"
      // dataSource={(payload && payload.page) || null}
      // loading={isLoading}
      pagination={false}
      // rowKey={(obj) =>
      //   `${obj.id}_${obj.type}_${obj.status}`
      // }
      rowKey={(obj) => 
        transactionsData === "list_invoices" ? `${obj.id}_${obj.amount}_${obj.status}` : `${obj.id}_${obj.status}`
      }
      rowSelection={{
        preserveSelectedRowKeys: false,
        selectedRowKeys: selected,
        onChange: onSelectChange,
      }}
    >
      {/* <Column
        title=""
        dataIndex="type"
        render={(type) => <span>{type === 'ord' ? <Tooltip title="Order"><ShoppingCartCheckoutOutlined /></Tooltip> : <Tooltip title="Invoice"><ReceiptOutlined /></Tooltip>}</span>}
      /> */}
      <Column
        title={`Replenishment ID`}
        dataIndex="id"
        render={(id) => <span>{id}</span>}
      />
      <Column
        title="Created"
        dataIndex="cre"
        render={(cre) => utcToDefaultFormat(cre)}
      /> 
      {/* <Column
        title="Replenished"
        dataIndex="cre"
        render={(creDate) => utcToDefaultFormat(creDate)}
      /> */}
      <Column
        title="Amount"
        dataIndex="amount"
        render={(amount) => <PrintAmount amount={amount} />}
      />
      <Column
        title="Status"
        dataIndex="status"
        render={(statusStr) => <PrintStatusInvoice status={statusStr} />}
      />
    </Table>
  );
}

export default ReplenishmentTable;
